export const REFERRAL_MONEY_DISCOUNT = "$35";
export const REFERRAL_FEATURE_DISCOUNT = "$99 advanced promotion";
export const REFERRAL_TOTAL_DISCOUNT = "$134";
export const REFERRER_COOKIE_NAME = "referrer";
export const REFERRER_COOKIE_MAX_AGE = 365*24*60*60; // in seconds
